export default __webpack_public_path__ + "static/media/pic_5.a34ae6ba.webp";